import React from 'react';
import { FormText, Label as BLabel } from 'reactstrap';
import { FormContext } from './Form';

export const NoteLabel = ({ required, children, note, ...props }) => {
  const context = React.useContext(FormContext);
  required = required || (context?.required || []).includes(props.for);

  return (
    <>
      <BLabel {...props}>
        {children}{' '}
        {required ? (
          <FormText inline color='danger' className='font-weight-bold'>
            * <span style={{ color: '#212529', fontStyle: 'oblique', marginLeft: '3px' }}>({note})</span>
          </FormText>
        ) : null}
      </BLabel>
    </>
  );
};

